import React, { FC, useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import CardTips from '../../../pages/Castings/MyCasting/components/CardTips'
import modalStyles from '../../../pages/Castings/MyCasting/components/brief-styles.module.scss'

export interface TipsTarget {
  _id: string
  name?: string
}

/**
 * Une candidature peut recevoir un tips tant que le createur n'est pas sorti du
 * flow. On ne peut pas se limiter a `won` : une collab en cours est en `step2`
 * ou `applied`, elle ne passe a `won` qu'a la cloture ou au paiement.
 */
const TIPS_EXCLUDED_STATUS = ['lost', 'declined', 'declined-client']

export const canReceiveTips = (status?: string) =>
  !!status && !TIPS_EXCLUDED_STATUS.includes(status)

interface SendTipsProps {
  /** Collabs du createur eligibles au tips. Aucun element = pas de bouton. */
  targets: TipsTarget[]
  className?: string
}

/**
 * Point d'entree unique du tips : un seul bouton, qui ouvre la modale sur place
 * (jamais de navigation), avec le meme rendu dans la messagerie, sur la fiche
 * createur et sur la fiche candidature.
 */
const SendTips: FC<SendTipsProps> = ({ targets, className }) => {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(false)

  if (!targets.length) return null

  const label = t('mycastings:private-deal:tips-title')

  return (
    <>
      <div className={`group relative inline-flex ${className ?? ''}`}>
        <button
          type="button"
          aria-label={label}
          onClick={() => setShowModal(true)}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-[#2CC1D6] bg-[#F2FDFF] text-[13px] text-[#2CC1D6] transition-colors duration-200 hover:bg-[#2CC1D6] hover:text-white"
        >
          <i className="fa-solid fa-hand-holding-dollar" />
        </button>
        {/* Infobulle au survol : l'icone seule suffit, le libelle reste dispo. */}
        <span className="pointer-events-none absolute left-1/2 top-[calc(100%+6px)] z-[30] -translate-x-1/2 whitespace-nowrap rounded-md bg-[#1b1b3a] px-2 py-1 font-hurmeBold text-[11px] leading-none text-white opacity-0 transition-opacity duration-150 group-hover:opacity-100">
          {label}
        </span>
      </div>
      {showModal && createPortal(
        // Portail : les conteneurs de chat sont transformes (framer-motion,
        // translate en tablette), un overlay fixe y serait mal positionne.
        <div className={`${modalStyles['parent-modal']} ${modalStyles['fixed-overlay']}`}>
          <CardTips
            setModalTips={setShowModal}
            idBa={targets[0]._id}
            briefApplications={targets}
          />
        </div>,
        document.body
      )}
    </>
  )
}

SendTips.defaultProps = {
  className: undefined
}

SendTips.propTypes = {
  targets: PropTypes.any.isRequired,
  className: PropTypes.string
}

export default SendTips
